import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  toggle() {
    const togglees = document.querySelectorAll(`[data-checkbox-togglee="${this.checkboxTarget.id}"]`)
    togglees.forEach((element) => element.classList.toggle("hidden"))
  }
}
